module.exports = __webpack_public_path__ + "static/img/bg_joinUS.9cb34ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/JoinUS/bg_joinUS.jpg
// module id = eJaH
// module chunks = 7